"use client";

import * as React from "react";

export interface AuthCustomInputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: string;
}

const AuthCustomInput = React.forwardRef<
	HTMLInputElement,
	AuthCustomInputProps
>(({ className, type, label, ...props }, ref) => {
	return (
		<div className="flex w-full flex-col gap-1.5">
			{label && (
				<label className="text-sm font-medium text-[#414651]">{label}</label>
			)}
			<input
				type={type}
				className={`h-11 w-full rounded-lg border border-[#D5D7DA] bg-white px-3.5 text-sm text-[#1A2314] shadow-[0_1px_2px_rgba(10,13,18,0.05)] transition placeholder:text-[#717680] focus:border-[#004A7C] focus:outline-none focus:ring-2 focus:ring-[#004A7C]/20 disabled:cursor-not-allowed disabled:opacity-50 ${className || ""}`}
				ref={ref}
				{...props}
			/>
		</div>
	);
});

AuthCustomInput.displayName = "AuthCustomInput";

export { AuthCustomInput };
